import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Tarifa } from '@mobile/app/shared/types/tarifa.type';

@Injectable({ providedIn: 'root' })
export class TarifasFirebaseService {
  constructor(private afs: AngularFirestore) {}

  async getBairros(): Promise<Tarifa[]> {
    const snapshot = await this.afs.firestore
      .collection('Tarifa')
      .where('ativo', '==', true)
      .orderBy('bairro')
      .get();
    return snapshot.docs.map(d => d.data() as Tarifa);
  }

  async getTarifa(bairro: string): Promise<Tarifa[]> {
    const snapshot = await this.afs.firestore.collection('Tarifa').where('bairro', '==', bairro).get();
    return snapshot.docs.map(d => d.data() as Tarifa);
  }
}
